const genericMediaIcons = document.querySelectorAll('#generic-media__slider .keen-slider__slide');

if (genericMediaIcons.length > 1) {
  var slider = new KeenSlider("#generic-media__slider", 
  {
    loop: true,
    breakpoints: {
      '(max-width: 449px)': {
        slides: {
          perView: 2.5,
        }
      },
      '(min-width: 450px) and (max-width: 749px)': {
        slides: {
          perView: 3.5,
        }
      },
      '(min-width: 750px)': {
        disabled: true,
      },
    },
  }, 
  [navigation])
}